"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _default = {
    topbar: {
        selectDepartment: "Selecteer hub"
    },

    menu: {
        home: 'Home',
        locations: 'Locaties',
        products: 'Producten',
        orders: 'Orders',
        cargos: 'Vrachten',
        stockImport: 'Voorraad importeren',
        customers: 'Klant',
        deviations: 'Afwijkingen'
    },
    ui: {
        search: 'Zoeken',
        close: 'Sluiten'
    },
    modal: {
        changes: {
            title: 'Weet je het zeker?',
            text: 'Er zijn wijzigingen die niet zijn opgeslagen',
            confirmButtonText: 'Sla niet op en ga verder',
            cancelButtonText: 'Annuleren'
        },
        "delete": {}
    },
    button: {
        back: 'Terug',
        add: 'Toevoegen',
        save: 'Opslaan',
        cancel: 'Annuleren',
        close: 'Sluiten',
        finish: 'Afronden',
        "export": 'Exporteren',
        "import": 'Importeren',
        ok: 'Oké',
        orders: 'Alle orders',
        start: 'Starten'
    },
    table: {
        search: 'Zoeken..',
        processing: 'Bezig..',
        noResults: 'Geen resultaten',
        noResultsDisplay: 'Geen resultaten gevonden',
        filteredFrom: '{0} tot {1} van {2} resultaten',
        noSearchResults: 'Er zijn geen zoekresultaten met:',
        first: 'Eerste',
        last: 'Laatste',
        next: 'Volgende',
        previous: 'Vorige',
        options: 'Opties'
    },
    form: {
        remark: 'Opmerking',
        optional: 'Optioneel',
        required: 'Dit veld is verplicht',
        inValid: 'Niet alle velden zijn juist ingevuld'
    },
    location: {
        title: 'Locaties',
        add: 'Locatie aanmaken',
        location: 'Locatie',
        description: 'Omschrijving',
        productPerLocation: 'Product per locatie',
        search: 'Locatie zoeken...',
        modalWarning: {
            title: 'Weet je het zeker?',
            description: 'Je kunt dit niet terugdraaien.',
            submit: 'Ja, verwijder locatie',
            cancel: 'Nee, annuleer'
        },
        alertRemoved: 'Verwijderd!',
        alertRemovedSuccess: 'Locatie is succesvol verwijderd.',
        deletionNotPossible: 'Locatie kan niet verwijderd worden, omdat 1 of meerdere producten aan de locatie gekoppeld is.',
        toasterAdded: 'Locatie aangemaakt',
        toasterEdited: 'Locatie aangepast',
        exist: 'Locatie bestaat al'
    },
    product: {
        title: 'Producten',
        add: 'Product aanmaken',
        product: 'Product',
        nameMissing: 'Productnaam is niet ingevuld',
        locationMissing: 'Locatie is niet ingevuld',
        stockMissing: 'Voorraad is niet ingevuld',
        productName: 'Productnaam',
        productNumber: 'Product Nr.',
        customer: 'Klant',
        reference: 'Referentie',
        name: 'Naam',
        type: 'Variant',
        location: 'Locatie',
        noLocationsFound: 'Geen locaties gevonden',
        locationStock: 'Locatie & voorraad',
        description: 'Omschrijving',
        pickInstructions: 'Pick instructies',
        stock: 'Voorraad',
        addStockBtn: 'Voeg voorraad toe',
        reservedStock: 'Gereserveerd',
        reservedStockNotify: 'Gereserveerde voorraad:',
        stockManagement: 'Voorraad beheer',
        search: 'Product zoeken...',
        noResults: 'Geen resultaten',
        modalWarning: {
            title: 'Weet je het zeker?',
            description: 'Je kunt dit niet terugdraaien.',
            submit: 'Ja, verwijder product',
            cancel: 'Nee, annuleer'
        },
        alertRemoved: 'Verwijderd!',
        alertRemovedSuccess: 'Product is succesvol verwijderd.',
        alertStockInfo: 'De voorraad is lager dan de gereserveerde voorraad.',
        alertStockConfirm: 'Ja, product bijwerken',
        alertEditStockConfirm: 'Ja, voorraad bijwerken',
        alertNotRemoved: 'Product niet verwijderd!',
        alertNotRemovedInfo: 'Een product met voorraad kan niet verwijderd worden.',
        toasterAdded: 'Product aangemaakt',
        toasterEdited: 'Product aangepast',
        exist: 'Product Nr. bestaat al'
    },
    order: {
        title: 'Orders',
        edit: 'Order',
        add: 'Order aanmaken',
        search: 'Order zoeken...',
        listNumber: 'Packing List nr.',
        receivedDate: 'ReleaseDate',
        deliveryDate: 'Leverdatum',
        releaseDate: 'Pick datum',
        amount: 'Aantal',
        reservedStock: 'Gereserveerd',
        reserveStock: 'Voorraad automatisch reserveren',
        status: {
            everything: 'Alles',
            status: 'Status',
            shortage: 'Manco',
            ready_for_release: 'Wachten op releasedatum',
            released: 'Ingepland',
            finished: 'Afgerond'
        },
        orderPickButton: 'Order picken',
        orderBeingPicked: 'Wordt verwerkt',
        finished: 'Afgerond',
        finishedDescription: 'Deze order is afgerond',
        clientName: 'Aflever naam',
        street: 'Aflever adres',
        houseNumber: 'Aflever Nr.',
        addition: 'Aflever toev.',
        zipcode: 'Aflever postcode',
        city: 'Aflever plaats',
        country: 'Aflever land',
        productMissing: 'Productnummer ontbreekt',
        modalWarning: {
            title: 'Weet je het zeker?',
            description: 'Je kunt dit niet terugdraaien.',
            submit: 'Ja, verwijder order',
            cancel: 'Nee, annuleer'
        },
        alertRemoved: 'Verwijderd!',
        alertRemovedSuccess: 'De order is succesvol verwijderd.',
        alertCannotDelete: 'Kan eerste order regel niet verwijderen',
        toasterAdded: 'Order aangemaakt',
        toasterEdited: 'Order aangepast',
        refresh: {
            success: 'Order status aangepast',
            warning: 'Order status niet aangepast'
        },
        noResults: 'Geen resultaten',
        exist: 'Packing List Nr. bestaat al'
    },
    orderPicking: {
        title: 'Order picken',
        check: 'Controle',
        orderRef: 'Ref.',
        pauseButton: 'Pauzeren',
        productName: 'Productnaam',
        type: 'Variant',
        location: 'Locatie',
        finishModal: {
            title: 'Order afronden',
            description: 'Aantallen komen niet overeen, afronden is niet mogelijk.',
            submit: 'Ok',
            cancel: 'Ok'
        },
        pauseModal: {
            title: 'Picken Pauzeren',
            description: 'Weetje zeker dat je het picken wilt pauzeren? ',
            submit: 'Ja, pauzeer',
            cancel: 'Nee, annuleer'
        }
    },
    customer: {
        title: 'Klanten',
        add: 'Klant aanmaken',
        edit: 'Klant',
        customer: 'Klant',
        name: 'Naam',
        address: 'Straat',
        addressNumber: 'Nr.',
        addition: 'Toev.',
        zipcode: 'Postcode',
        city: 'Plaats',
        country: 'Land',
        phoneNumber: 'Telefoonnummer',
        email: 'E-mail',
        search: 'Klant zoeken..',
        alertRemoved: 'Verwijderd!',
        alertUpdated: 'Klant aangepast',
        alertAdded: 'Klant aangemaakt',
        modalWarning: {
            title: 'Weet je het zeker?',
            description: 'Je kunt dit niet terugdraaien.',
            submit: 'Ja, verwijder klant',
            cancel: 'Nee, annuleer'
        }
    },
    deviations: {
        portletTitle: 'Afwijkingen',
        title: 'Meld een afwijking',
        search: 'Afwijking zoeken',
        removeImage: 'Afbeelding verwijderen?',
        chooseDeviation: 'Kies een afwijking',
        uploadPicture: 'Upload een foto',
        amount: 'Aantal',
        deviations: {
            shortage: 'Manco',
            unit: 'Eenheid',
            excess: 'Teveel',
            damaged: 'Beschadigd',
            exceedsCargoLimits: 'Past niet',
            exceeds_cargo_limits: 'Past niet',
            PRESENT_ON_FLOOR: "Op vloer aanwezig gemeld"
        },
        table: {
            location: 'Locatie',
            dateRange: 'Filter',
            locationAdditional: 'Extra info',
            type: 'Soort afwijking',
            img: 'Afbeelding',
            time: 'Gemeld op',
            user: 'Melder'
        },
        added: 'Afwijking gemeld',
        modals: {
            "delete": {
                title: 'Weet je zeker dat je deze afwijking wilt verwijderen',
                html: 'Wilt u deze record echt verwijderen? Dit proces kan niet ongedaan worden gemaakt',
                confirmButtonText: 'Verwijderen',
                cancelButtonText: 'Annuleren'
            }
        }
    },
    cargo: {
        startLoading: {
            title: 'Wil je beginnen met laden?',
            reference: 'Referentie:',
            etd: 'ETD:'
        },
        title: 'Vrachten',
        cargo: 'Vrachten',
        add: 'Vracht aanmaken',
        search: 'Vracht zoeken',
        name: 'Naam',
        etd: 'Geschatte vertrekttijd (ETD)',
        reference: 'Referentie',
        number: 'Vracht Nr.',
        allOrders: 'Orders',
        addedOrders: 'Gekoppelde orders',
        noAvailableOrders: 'Geen beschikbare orders',
        releaseDate: 'Release datum',
        toasterAdded: 'Vracht aangemaakt',
        toasterEdited: 'Vracht aangepast',
        toasterRemoved: 'Vracht verwijderd!',
        modalWarning: {
            title: 'Weet je het zeker?',
            description: 'Je kunt dit niet terugdraaien.',
            submit: 'Ja, verwijder Vracht',
            cancel: 'Nee, annuleer'
        },
        "delete": {
            ordersAttached: 'Er zijn orders gelinked aan deze vracht..'
        },
        exists: 'Vracht met dezelfde referentie bestaat al'
    },
    shopfloor: {
        modalProductScanned: {
            submit: 'Product geladen',
            title: 'Barcode gescand',
            productScannedUnknownInCargo: 'product {0} is onbekend',
            alreadyUnloaded: 'Product is al gelost',
            alreadyUnloadedOnLocation: "Product is al gelost op:",
            html: '{0} <br> product onbekend <br><br> <strong>Wacht op locatie..</strong>',
            productHtml: '%{product_number} <br> %{productName} <br> Referentie: %{reference} <br> Variant: %{variant} <br> Ontvanger: %{receiverName} <br> Postcode: %{receiverZipCode} <br> Plaats: %{receiverCity}',
            loadingProductHtml: '%{productNumber} <br> Naam: %{productName} <br> Referentie: %{reference} <br> Variant: %{variant}'
        },
        cargoOrder: {
            showDeviations: {
                title: 'Afwijkingen',
                productNumber: 'Barcode',
                packingListNumber: 'Dossiernr',
                type: "Type",
                createdBy: "Gemeld door"
            }
        },
        deviations: {
            undo: "Afwijking ongedaan maken",
            dialogConfirm: {
                title: 'Afwijking verwijderen',
                message: 'Wil je de afwijking verwijderen?',
                confirm: 'Ja',
                dismiss: 'Nee'
            },
            pickLocationDialog: {
                title: 'Waar staat dit product?',
                message: 'Vul de locatienaam in',
                confirm: 'Bevestig',
                dismiss: 'Annuleer',
                errorNoLocation: 'Je moet een locatie invoeren.',
                errorNoValidLocation: 'Geen geldige locatie ingevoerd.'
            },
            pickLocationScanDialog: {
                title: 'Waar staat dit product?',
                message: 'Scan de locatie waar dit product staat',
                dismiss: 'Annuleren'
            },
            selectedProduct: 'Barcode:',
            amount: 'Aantal',
            type: 'Type',
            createdAt: 'Gemeld op',
            createdBy: 'Gemeld door',
            remark: 'Opmerking',
            noDeviations: 'Geen afwijkingen gevonden',
            undoneSuccess: 'Afwijking ongedaan gemaakt',
            alreadyDeleted: 'Deze afwijking wordt al verwijderd.',
            types: {
                shortage: 'Manco',
                unit: 'Eenheid',
                excess: 'Teveel',
                damaged: 'Beschadigd',
                exceedsCargoLimits: 'Past niet',
                exceeds_cargo_limits: 'Past niet',
                PRESENT_ON_FLOOR: "Op vloer aanwezig gemeld"
            }
        },
        emptyTruck: {
            text: 'Scan auto',
            title: 'Auto leegmelden',
            confirm: 'Auto leegmelden',
            success: 'De auto is leeggemeld.'
        },
        forgotLocationModal: {
            title: 'Oeps',
            message: 'Verkeerde scan, dit is geen locatie.',
            button: 'Annuleer'
        },
        modalTransportScanned: {
            title: 'Auto leegmelden',
            context: 'Er zijn nog [AANTAL] goederen te lossen.',
            confirm: 'Leegmelden',
            noneLeft: {
                title: 'Eerder leeggemeld',
                context: 'Deze auto is al leeggemeld.',
                close: 'Sluiten'
            }
        },
        homePage: {
            startLoading: 'Start met laden',
            startUnloading: 'Start met lossen'
        },
        delay: 'Je kunt pas weer scannen na: {0} seconden',
        menu: {
            teamlead: {
                users:"Gebruikers",
                productOverview: 'Product overzicht',
                senderOverview: 'Opdrachtgever overzicht',
                cargoOverview: 'Te laden vracht',
                cargoUnloadingOverview: 'Te lossen vracht',
                orderHandling: 'Order afhandeling',
                cargoHandling: 'Vracht afhandeling',
                deviations: 'Afwijkingen',
                dockSuggestions: 'Dock suggesties'
            },

            stockChange: 'Voorraad mutatie',
            loodsopname: 'Crossdockopname',
            cycleCount: 'Cycle count',
            scanTraceableProduct: "Track en trace"
        },
        teamlead: {
            users:{
                name:"Naam",
                usernumber:"code",
                fullName: "Naam",
                position:" Functie",
                rights:"Rechten",
                leaveDate:"Contract einde",
                lastLogin:"Laatste login"
            },
            senderOverview: {
                selectSender: 'Selecteer opdrachtgever',
                table: {
                    orderDate: 'Order datum',
                    deliveryDate: 'Lever datum',
                    packingListNumber: 'Pakbon',
                    receiver: 'Ontvanger',
                    sender: 'Sender'
                }
            },
            missingGoods: {
                action: 'Ontbrekende goederen bekijken',
                trailerTruck: "Auto - trailer",
                eta: "ETA",
                productNumber: "Barcode",
                customer: "Klant",
                packingListNumber: "Dossiernr.",
                productName: "Eenheid",
                progress: "Aantal",
                truckCleared: "Leeggemeld"
            },
            orderHandling: {
                orderHandlingOpen: 'Order afhandeling openen',
                resetFilter: 'Reset filters',
                customer: 'Klant',
                noCustomerName: 'Geen klantnaam',
                cargoNumber: "Vrachtnummer",
                fromDate: "Van",
                toDate: "Tot",
                amountOfOrders: "Aantal orders",
                truck: 'Auto',
                openFilter: 'Open filters',
                closeFilter: 'Verberg filters',
                receiver: 'Ontvanger',
                sender: 'Opdrachtgever',
                trailer: 'Trailer',
                date: {
                    unloading: 'ETA',
                    loading: 'ETD'
                },
                productNumber: 'Barcode',
                address: 'Adres',
                packingListNumber: 'Dossiernr.',
                state: 'Status',
                type: 'Eenheid',
                filter: 'Zoeken',
                noTruckNumber: 'Geen auto',
                noReceiverName: 'Geen ontvanger',
                noTrailerNumber: 'Geen trailer',
                buttons: {
                    declareDefect: 'Manco melden',
                    unload: 'Fictief lossen'
                },
                actions: {
                    manco: {
                        title: 'Manco melden',
                        busy: 'Manco melden wordt verwerkt...',
                        done: 'Klaar met manco melden',
                        message: 'Weet je zeker dat je [AMOUNT] goederenregel(s) wil manco melden?',
                        confirm: 'Manco melden',
                        cancel: 'Annuleren'
                    },
                    unload: {
                        title: 'Fictief lossen',
                        busy: 'Fictief lossen wordt verwerkt...',
                        done: 'Bezig met fictief lossen. <br> Verwerking kan even duren...',
                        message: 'Weet je zeker dat je [AMOUNT] goederenregel(s) fictief wilt lossen?',
                        confirm: 'Fictief lossen',
                        cancel: 'Annuleren'
                    }
                },
                maxSelected: {
                    title: 'Maximum aantal orders geselecteerd',
                    message: 'Het is niet toegestaan om meer dan 200 goederenregels in één keer te bewerken. Pas een filter toe of selecteer minder goederenregels.',
                    closeButton: 'Sluiten'
                },
                progress: 'Aantal',
                trailerNumber: 'Trailer',
                selectedDate: 'Geselecteerde datum',
                states: {
                    title: 'Status',
                    loading: {
                        idle: 'Niet geladen',
                        busy: 'Laden gestart',
                        done: 'Volledig geladen'
                    },
                    unloading: {
                        idle: 'Niet gelost',
                        busy: 'Lossen gestart',
                        done: 'Volledig gelost'
                    },
                    idle: 'Niet geladen',
                    busy: 'Laden gestart',
                    done: 'Volledig geladen'
                },
                view: {
                    title: 'Weergave',
                    loading: 'Laden',
                    unloading: 'Lossen'
                }
            },
            deviations: {
                dateFilter: 'Geselecteerde datum',
                typeFilter: {
                    title: 'Soort afwijking',
                    filtered: 'Gefilterd'
                },
                deviations: {
                    shortage: 'Manco',
                    unit: 'Eenheid',
                    excess: 'Teveel',
                    damaged: 'Beschadigd',
                    exceedsCargoLimits: 'Past niet',
                    exceeds_cargo_limits: 'Past niet',
                    PRESENT_ON_FLOOR: "Op vloer aanwezig gemeld"
                },
                type: 'Afwijking',
                remark: 'Opmerking',
                customer: 'Klant',
                address: 'Adres',
                packingListNumber: 'Dossiernr',
                productName: 'Eenheid',
                amount: 'Aantal',
                createdAt: 'Gemeld op',
                userName: 'Naam',
                url: 'Url',
                truck: 'Auto',
                trailer: 'Trailer',
                productNumber: 'Barcode',
                openUrl: 'Klik hier'
            },
            dockSuggestions: {
                truck: 'Auto',
                trailer: 'Trailer',
                reference: 'Referentie',
                selectedDate: 'Geselecteerde datum',
                view: {
                    title: 'Weergave',
                    loading: 'Laden',
                    unloading: 'Lossen'
                },
                eta: 'ETA',
                etd: 'ETD',
                suggestionOne: 'Postcode suggestie 1',
                suggestionTwo: 'Postcode suggestie 2',
                printing: 'Suggesties worden gemaild.'
            },
            loading: {
                saveSuccess: 'Successvol opgeslagen',
                manualAdjustment: 'Handmatige aanpassing',
                outgoingCargo: {
                    reference: 'Referentie',
                    startTime: 'Starttijd',
                    etd: 'ETD',
                    openUser: 'Uitgevoerd door'
                },
                toggleDone: 'Aan/uitzetten afgeronde vrachten',
                legendTitle: 'Legenda',
                legend: {
                    toggle: 'Aan uitzetten van afgeronde orders',
                    green: 'Gecontroleerd en geladen',
                    orange: 'Geen barcode. Handmatig controleren',
                    blue: 'Aanwezig op de laadvloer en bekend waar het staat',
                    white: 'Zending is nog niet gelost'
                }
            },
            unloading: {
                vdh: {
                    reference: 'Auto',
                    clearedTitle: 'Leeggemeld',
                    clearedYes: 'Ja',
                    clearedNo: ''
                },
                reference: 'Referentie',
                articleNr: 'Artikel NR',
                location: 'Locatie',
                startTime: 'Starttijd',
                endTime: 'Eindtijd',
                employee: 'Medewerker',
                incomingCargo: {
                    reference: 'Referentie',
                    startTime: 'Start tijd',
                    endTime: 'Eind tijd',
                    eta: 'ETA'
                },
                toggleDone: 'Aan/uitzetten geloste vrachten',
                legendTitle: 'Legenda',
                legend: {
                    toggle: 'Aan uitzetten van geloste orders',
                    green: 'Gecontroleerd en geslost',
                    orange: 'Barcode niet scanbaar. Handmatig controleren',
                    blue: 'Beschikbaar om te lossen en bekend waar het staat',
                    white: 'Nog niet beschikbaar om te lossen'
                }
            },
            manual: {
                productloaded: 'Product volledig geladen',
                productNotLoaded: 'Product nog niet (volledig) geladen',
                description: 'Op deze pagina kan de laadorder handmatig aangepast worden.',
                orderProduct: {
                    unloadTitle: 'Handmatige aanpassing',
                    unloadDescription: 'Kies eerst een locatie, daarna kan het aantal ingesteld worden voor handmatige aanpassing',
                    locationForUnload: 'Locatie',
                    amountUnloaded: 'Kies aantal te lossen artikelen',
                    amountPickableTitle: 'Aantal te laden',
                    amountUnloadPickableTitle: 'Aantal te lossen',
                    amountPickable: 'Aantal te laden',
                    unloadAmountDescription: 'Deze wijziging wijzigt het aantal producten dat gelost dient te worden.',
                    description: 'Deze wijziging wijzigt het aantal producten dat geladen dient te worden.'
                },
                picklocation: {
                    amountPickedTitle: 'Aantal te laden',
                    amountPickable: 'Aantal te laden',
                    description: 'Deze wijziging wijzigt het aantal producten dat geladen dient te worden.',
                    pickedAmountTitle: 'Aantal reeds geladen',
                    pickedAmountDescription: 'Deze wijziging wijzigt het aantal producten dat reeds geladen is.' + ' <br> Aanpassingen zijn ook van invloed op de voorraad.',
                    pickedAmount: 'Geladen producten'
                }
            }
        },
        stockChanges: {
            explanation: '<h4> Voorraad verplaatsen</h4> <p>Op deze pagina kunnen voorraad mutaties worden verricht</p>',
            scanProduct: 'Scan product',
            manualBarcode: 'Vul barcode handmatig in',
            selectProduct: 'Selecteer of scan product',
            noProductsYet: 'Producten laden..',
            selectAmount: 'Kies aantal producten',
            selectToLocation: 'Scan nieuwe locatie',
            scanLocationTo: 'Scan nieuwe locatie',
            stockUpdated: 'Voorraad verplaatst',
            modalSameLocation: 'Plaatsen op dezelfde locatie is niet mogelijk',
            modalLocationFirst: 'Scan eerst een locatie',
            unknownBarcode: {
                title: 'Barcode onbekend',
                message: 'Geen product gevonden met deze barcode.',
                button: 'Sluiten'
            },
            barcodeInsteadOfLocation: {
                title: 'Product gescand',
                message: 'Je hebt een product gescand in plaats van een locatie.',
                button: 'Sluiten'
            },
            sameLocation: {
                title: 'Dezelfde locatie gescand',
                message: 'Je product staat al op deze locatie',
                button: 'Sluiten'
            },
            productScannedModal: {
                title: 'Op locatie plaatsen',
                scannedProductNumber: '<b>Gescande productcode:</b> %{productNumber}.<br><b>Aantal op voorraad op dit moment:</b> %{stock}.',
                moveLocation: 'Verplaatsen vanaf %{location}',
                createStock: 'Op voorraad plaatsen',
                cancel: 'Annuleren',
                next: 'Volgende'
            },
            scanNewLocationModal: {
                title: 'Op locatie plaatsen',
                message: 'Scan de juiste locatie.',
                messageNoStock: 'Geen voorraad bekend. Scan een locatie om op voorraad te zetten.',
                cancel: 'Annuleren'
            },
            locationMovementResult: {
                success: 'Voorraad verplaatst',
                error: 'Voorraad niet verplaatst',
                busy: 'Bezig met verplaatsen...'
            },
            stockCreatedResult: {
                success: 'Voorraad aangemaakt',
                error: 'Voorraad niet aangemaakt',
                busy: 'Bezig met op voorraad zetten...'
            }
        },
        status: {
            started: 'Laden gestart',
            initial: 'Niet geladen',
            done: 'Volledig geladen',
            waiting: 'Niet geladen',
            loading: 'Bezig met laden'
        },
        unloading: 'Lossen',
        loading: 'Laden',
        unloadingPage: {
            noUnloading: 'Scan barcode',
            manualBarcode: 'Vul barcode handmatig in',
            cargoFinishedStatus: 'Afgerond',
            finishCargo: 'Vracht als afgerond melden',
            cargoFinished: 'Vracht is afgerond gemeld',
            model: {
                finishCargo: {
                    title: 'Vracht afronden',
                    textNormal: 'Wil je deze vracht als afgerond melden?',
                    textNotFinished: 'Je hebt nog niet alle producten geladen.',
                    confirmButtonText: 'Ja',
                    cancelButtonText: 'Nee'
                }
            },
            cargoFinishedSuccessfully: 'Vracht is afgerond'
        },
        loadingPage: {
            barcodeUnreadable: 'Barcode onleesbaar.',
            barcodeUnreadableButton: 'Barcode onleesbaar. Scan hier',
            orders: {
                noOrders: 'Geen orders'
            },
            loaded: '{0} geladen',
            scanCargoTitle: 'Wacht op vracht scan',
            scanCargo: '<p>Scan vracht <strong>%{cargoNumber}</strong> voor het zojuist gescande product <strong>%{productNumber}</strong> </p>',
            wrongTrailerTitle: 'Verkeerde vracht gescand',
            wrongTrailer: '<strong>%{productNumber}</strong> dient geladen te worden in <strong>%{cargoNumber}</strong> </p>',
            unknownLocationInCargo: 'Gescande locatie is onbekend in deze vracht',
            unknownProductInCargo: 'Product {0} hoort niet in deze vracht',
            locationKnown: 'Je kunt nu producten scannen van locatie {0}',
            isNotALocation: 'Dit is geen locatie, scan eerst een locatie',
            locationUnknownForProduct: 'Product is onbekend op de gescande locatie',
            syncStock: 'Controleer voorraad',
            busySyncing: 'Bezig met controleren. Dit kan even duren.',
            syncStockDone: 'Voorraad is gecontroleerd.',
            syncStockFailed: 'Kon de voorraad niet controleren.'
        },
        startTime: 'Begintijd',
        endTime: 'Eindtijd',
        modalWarning: {
            loggedIn: 'Wat zou je willen doen',
            unloading: 'Lossen',
            loading: 'Laden',
            cancel: 'Annuleer',
            barcodeScanned: 'Barcode gescand',
            submit: 'Ja',
            title: 'Oops'
        },
        modalErrorLocationScanned: {
            title: 'Oopsie',
            text: 'Locatie gescanned zonder product..'
        },
        modalExistingOrderInProgress: {
            title: 'Weet je het zeker?',
            text: 'Bestelling wordt uitgevoerd!'
        },
        modalBarcodeScanned: {
            text: 'Bestelling wordt al gepikt!'
        },
        modalAmountAlreadyPicked: {
            html: '%{name} (%{product_number}) is al geladen  voor order <br>  %{orderId} <br>'
        },
        modalUnknownProductCode: {
            text: 'Deze streepjescode is niet bekend in deze order!'
        },
        modalUnknownLocation: {
            text: 'Product is niet voldoende op voorraad'
        },
        modalUnknownProduct: {
            text: 'Dit product is niet bekend!'
        },
        order: {
            destination: 'Bestemming',
            client: 'Opdrachtgever'
        },
        trackAndTrace: {
            scanTraceableProduct: "Track en trace",
            history: "Historie",
            endOfImport: "Einde import",
            startOfImport: "Import gestart",
            productNumber: "Barcode",
            productName: "Eenheid",
            noEvents: 'Geen historie bekend.',
            loadingEvents: 'Bezig met laden...',
            packingListNumber: 'Dossiernr.',
            deviation: {
                shortage: 'Manco',
                unit: 'Eenheid',
                excess: 'Teveel',
                damaged: 'Beschadigd',
                exceedsCargoLimits: 'Past niet',
                exceeds_cargo_limits: 'Past niet',
                PRESENT_ON_FLOOR: "Op vloer aanwezig gemeld"
            },
            statusCode: 'Statuscode',
            watchTrackAndTrace: 'Track en trace bekijken',
            deviationNote: 'Opmerking',
            statusCodes: {
                100: 'Ingevoerd',
                110: 'Ingepland',
                130: 'Afhalen',
                140: 'Afgehaald',
                150: 'Niet afgehaald',
                160: 'Geladen met opmerking',
                170: 'Aankomst depot',
                173: 'Manco',
                174: 'Gedeeltelijk manco',
                180: 'Lossen depot',
                181: 'Lossen depot',
                182: 'Lossen depot',
                183: 'Lossen depot',
                184: 'Lossen depot',
                185: 'Lossen depot',
                186: 'Lossen depot',
                190: 'Gelost depot',
                193: 'Laden depot (past niet)',
                200: 'Laden depot',
                210: 'Geladen depot',
                220: 'Start rit',
                230: 'Ontpland',
                240: 'Afleveren',
                250: 'Afgeleverd',
                260: 'Niet afgeleverd',
                270: 'Deellevering',
                280: 'Aflevering met opmerking',
                290: 'Nalevering gemaakt',
                901: 'Uitgepland',
                902: 'Uitgepland'
            },
            eventTitles: {
                'USER_UNLOAD': 'Gelost',
                'STOCK_CHANGE_UNLOAD': 'Gelost via voorraadmutatie',
                'UNDONE_DEVIATION_UNLOAD': 'Gelost door verwijderde afwijking',
                'FICTIONAL_UNLOAD': 'Fictief gelost',
                'STOCK_CHANGE': 'Mutatie',
                'USER_LOAD': 'Geladen',
                'UNDONE_DEVIATION': 'Verwijderd',
                'START_IMPORT': 'Import gestart',
                'STOP_IMPORT': 'Import gestopt',
                'MANUAL_ADJUSTMENT_BARCODE_UNREADABLE_CHANGED': 'Barcode onleesbaar gewijzigd',
                'MANUAL_ADJUSTMENT_TO_PICK_CHANGED': 'Te laden aantal gewijzigd',
                'MANUAL_ADJUSTMENT_PICKED_CHANGED': 'Geladen aantal gewijzigd'
            },
            barcodeUnreadableChanged: 'Barcode',
            barcodeUnreadableChangedYes: 'onleesbaar',
            barcodeUnreadableChangedNo: 'leesbaar',
            manualChangeAppliesToPickLocation: 'Aanpassing geldt voor alles op locatie',
            manualAdjustmentPickedIncrement: 'Verhoogd met',
            manualAdjustmentPickedDecrement: 'Verlaagd met',
            manualAdjustmentToPickIncrement: 'Verhoogd met',
            manualAdjustmentToPickDecrement: 'Verlaagd met',
            oldValue: 'Vorige waarde',
            newValue: 'Nieuwe waarde',
            sourceCargoReference: 'Van',
            destinationLocation: 'Naar',
            sourceLocation: 'Van',
            declaredDuring: 'Gemeld tijdens',
            declaredDuringLocations: {
                loading: 'Laden',
                unloading: 'Lossen'
            },
            amount: 'Aantal',
            cargoReference: 'Vracht',
            destinationCargoReference: 'Naar'
        },
        cyclecount: {
            currentScan: 'Huidige scan',
            stopCycleCount: 'Beëindig cycle count',
            startCycleCount: 'Start cycle count',
            startingCycleCount: 'Cycle count starten',
            startingDialog: 'Alle voorraad wordt verwijderd op het moment dat je hiermee start.<br><br>De scanners worden geblokkeerd totdat je de cycle count beëindigd.<br><br>Weet je zeker dat je hiermee wilt starten?',
            startingDialogConfirm: 'Starten',
            startingDialogCancel: 'Annuleren',
            nobodyCounting: 'Niemand',
            counting: 'Bezig met tellen',
            clearingStock: 'Bezig met het opruimen van de voorraad. Een ogenblikje geduld a.u.b.',
            previousScannedProducts: 'Vorige gescande producten',
            nothingScanned: 'Nog geen product gescand',
            scanLocation: 'Scan de locatie',
            scanProduct: 'Scan een product',
            manualBarcode: 'Voer barcode handmatig in',
            cancelScan: 'Deze scan (%{productNumber}) annuleren',
            requestFailed: 'Er is iets misgegaan. Probeer het nog eens.',
            product: 'Product',
            amountLoaded: 'Aantal geladen',
            deviations: 'Afwijkingen',
            noDeviations: 'geen gemeld.',
            deviation: {
                shortage: 'Manco',
                unit: 'Eenheid',
                excess: 'Teveel',
                damaged: 'Beschadigd',
                exceedsCargoLimits: 'Past niet',
                exceeds_cargo_limits: 'Past niet',
                PRESENT_ON_FLOOR: "Op vloer aanwezig gemeld"
            },
            outgoingCargo: 'Laden',
            locations: 'Locaties',
            noLocations: 'Niet via scanner gelost',
            unknownBarcode: 'Barcode is onbekend.',
            noOutgoingCargo: "Nog niet gepland",
            productNumber: 'Barcode',
            productName: 'Product',
            locationName: 'Locatie',
            stock: 'Voorraad',
            stopCycleCountDialog: {
                title: 'Beëindig cycle count',
                message: 'Hiermee beëindig je de cycle count. Zodra iedereen die bezig is, de cycle count beëindigd heeft; worden de scanners vrijgegeven voor gebruik.',
                dismiss: 'Terug gaan',
                confirm: 'Beëindig cycle count'
            },
            decrementStockSuccessfull: 'Voorraad verminderd.',
            blockedTitle: 'Applicatie geblokkeerd',
            blockedMessage: 'Op dit moment is er een cycle count bezig. Hierom is de applicatie geblokkeerd. De applicatie wordt vrijgegeven wanneer iedereen klaar is met de cycle count.'
        },
        loodsopname: {
            currentScan: 'Huidige scan',
            noCargoFound: 'Kan afwijking niet melden: geen inkomende vracht bekend.',
            nothingScanned: 'Nog geen product gescand',
            scanProduct: 'Scan een product',
            manualBarcode: 'Voer barcode handmatig in',
            nextProduct: 'Volgende',
            requestFailed: 'Er is iets misgegaan. Probeer het nog eens.',
            loadThisProduct: 'Laad dit product!',
            presentOnFloorSend: 'Product in crossdock aanwezig gemeld.',
            checkCargoStillHere: 'Kan deze zending nog geladen worden?',
            product: 'Product',
            amountLoaded: 'Aantal geladen',
            deviations: 'Afwijkingen',
            noDeviations: 'geen gemeld.',
            deviation: {
                shortage: 'Manco',
                unit: 'Eenheid',
                excess: 'Teveel',
                damaged: 'Beschadigd',
                exceedsCargoLimits: 'Past niet',
                exceeds_cargo_limits: 'Past niet',
                PRESENT_ON_FLOOR: "Op vloer aanwezig gemeld"
            },
            outgoingCargo: 'Laden',
            locations: 'Locaties',
            noLocations: 'Niet via scanner gelost',
            checkCargo: 'Controleer vracht',
            cargoNotPresent: 'Nee',
            cargoPresent: 'Ja',
            unknownBarcode: 'Barcode is onbekend.',
            noOutgoingCargo: "Nog niet gepland"
        }
    },
    dashboard: {
        done: 'Orders gereed',
        shortage: 'Manco order',
        planned: 'Nog te plannen orders'
    },
    startTime: 'Begintijd',
    endTime: 'Eindtijd',
    modalWarning: {
        loggedIn: 'Wat zou je willen doen',
        unloading: 'Lossen',
        loading: 'Laden',
        cancel: 'Annuleer',
        barcodeScanned: 'Barcode gescand',
        submit: 'Ja',
        title: 'Oops'
    },
    modalErrorLocationScanned: {
        title: 'Oopsie',
        text: 'Locatie gescanned zonder product..'
    },
    modalExistingOrderInProgress: {
        title: 'Weet je het zeker?',
        text: 'Bestelling wordt uitgevoerd!'
    },
    modalBarcodeScanned: {
        text: 'Bestelling wordt al gepikt!'
    },
    modalAmountAlreadyPicked: {
        html: '%{name} (%{product_number}) is al geladen  voor order <br>  %{orderId} <br>'
    },
    modalUnknownProductCode: {
        text: 'Deze streepjescode is niet bekend in deze order!'
    },
    modalUnknownLocation: {
        text: 'Product is niet voldoende op voorraad'
    },
    pagination: {
        previous: 'Vorige',
        next: 'Volgende'
    },
    "import": {
        title: 'Voorraad importeren',
        explanation: 'Upload een excel bestand en vul de kolom titels in op de juiste plek.',
        uploadFile: 'Upload bestand',
        chooseFile: 'Kies bestand',
        selectedFiled: 'Geüpload bestand:',
        productNumber: 'Product nummer kolom',
        location: 'Locatie kolom',
        stock: 'Voorraad kolom',
        alert: {
            success: 'Producten succesvol geüpdatet',
            notall: 'Niet alle producten succesvol geüpdatet',
            warning: 'Mislukt',
            warningText: 'Een of meerdere kolom namen komen niet overheen.'
        }
    },
    whatDoYouWantToDo: 'Wat wil je doen?'
};
exports["default"] = _default;